import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../utils/formatters';

/**
 * SummaryCard - Individual summary card for desktop view
 * Used to display financial metrics in a grid layout
 */
const SummaryCard = ({ title, value, currency = 'BRL', isHighlighted = false }) => (
  <Card
    variant="outlined"
    sx={{
      height: '100%',
      borderColor: isHighlighted ? 'success.light' : 'divider',
      position: isHighlighted ? 'relative' : 'static',
      bgcolor: isHighlighted ? 'rgba(29, 165, 122, 0.05)' : 'background.paper',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      },
      '&::before': isHighlighted ? {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        bgcolor: 'success.main',
      } : {}
    }}
  >
    <CardContent>
      <Typography color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography
        variant="h5"
        component="div"
        sx={{
          color: 'text.primary',
          fontWeight: isHighlighted ? '600' : 'normal'
        }}
      >
        {formatCurrency(value, currency)}
      </Typography>
    </CardContent>
  </Card>
);

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string,
  isHighlighted: PropTypes.bool
};

export default SummaryCard;